// Pure logic for the B7 global-search overlays. No DOM, no React, no fetch.
// Attached to window.mindexSearch by vendor.entry.js.

// Escape regex metacharacters so a literal-mode query matches verbatim once
// it reaches the engine's WASM regex verify. Mirrors the set escaped in
// core's grep.ts SNIPPET path; `%`/`_` are SQL metachars handled server-side,
// not regex metachars, so they are left alone here.
export function escapeRegexLiteral(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Group a flat GrepContentMatch[] (engine order) into per-file groups.
export function groupGrepMatches(matches) {
  const groups = [];
  let cur = null;
  for (const m of matches) {
    if (!cur || cur.path !== m.file_path) {
      cur = { path: m.file_path, hits: [] };
      groups.push(cur);
    }
    cur.hits.push({ line_no: m.line_no, line: m.line });
  }
  return groups;
}

// Subsequence fuzzy match. Returns true + a score (lower = better) or null.
// Score favors: a contiguous basename hit, an earlier first-match index, and
// shallower paths. Deterministic — no time/random.
function scoreOne(path, q) {
  const lower = path.toLowerCase();
  const base = path.slice(path.lastIndexOf('/') + 1).toLowerCase();
  const idxBase = base.indexOf(q);
  if (idxBase >= 0) return idxBase + path.split('/').length * 0.01; // basename hit
  // fall back to a subsequence match over the full path
  let qi = 0, first = -1;
  for (let i = 0; i < lower.length && qi < q.length; i++) {
    if (lower[i] === q[qi]) { if (first < 0) first = i; qi++; }
  }
  if (qi < q.length) return null;
  return 1000 + first; // worse than any basename hit
}

export function fuzzyRankFiles(files, query) {
  const q = query.toLowerCase().trim();
  if (q === '') return files.slice();
  const scored = [];
  for (const f of files) {
    const s = scoreOne(f.path, q);
    if (s !== null) scored.push({ f, s });
  }
  scored.sort((a, b) => (a.s - b.s) || a.f.path.localeCompare(b.f.path));
  return scored.map((x) => x.f);
}

// Wrap a single-cursor index by `dir` (+1/-1) over `len` rows.
export function nextCursor(cur, len, dir) {
  if (len <= 0) return 0;
  return (cur + dir + len) % len;
}

export function isCommandMode(query) {
  return query.startsWith('>');
}

// Filter a command list ({ id, label, ... }) by the text after the leading '>'.
export function filterCommands(commands, query) {
  const q = query.replace(/^>\s*/, '').toLowerCase();
  if (q === '') return commands.slice();
  return commands.filter((c) => c.label.toLowerCase().includes(q));
}
